import { FetchBaseQueryError, createApi } from '@reduxjs/toolkit/query/react'

import { HYDRATE } from 'next-redux-wrapper'

import { SANITY } from '~/services/sanity.service'
import { apiPrivate } from '~/redux/utils/hom-api'
import { Infos } from '~/types/index'

export const homInfoApi = createApi({
  reducerPath: 'usersCountApi',
  baseQuery: apiPrivate,
  tagTypes: ['UsersCount'],
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (build) => ({
    getHomInfo: build.query<Infos | null, void>({
      queryFn: async () => {
        try {
          return { data: await SANITY.getUserCount() }
        } catch (error) {
          return { error: error as FetchBaseQueryError }
        }
      },
    }),
  }),
})

export const {
  useGetHomInfoQuery,
  util: { getRunningQueriesThunk },
} = homInfoApi

export const { getHomInfo } = homInfoApi.endpoints
